import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
            热门赛事分类
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            探索您喜爱的体育项目
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base">
            涵盖全球最受欢迎的体育赛事，无论您钟爱哪项运动，都能在这里找到最专业的赛事分析
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-6 text-center border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-primary-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed hidden md:block">
                {cat.description.length > 40 ? cat.description.slice(0, 40) + '...' : cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}